import * as _ from 'lodash';
import * as EnumValues from '../misc/EnumValues';
import * as utility from '../misc/utility';
import { PersonPhotoManager } from './PersonPhotoManager';

angular.module("tromanWeb").controller('PersonEditController', ['stateService', 'dialogService', 'tromanServer', 'personState', 'systemInfo', function (stateService, dialogService, tromanServer, personState, systemInfo) {

    var isSaving = false;

    this.table = null;
    this.items = null;
    this.systemInfo = systemInfo;

    this.person = personState.person.clone();
    this.person.initEdit();
    this.shared = personState;
    this.photoWarning = null;
    this.photoManager = new PersonPhotoManager(personState.photo);

    stateService.guard(() => this.shared.form.$dirty || this.photoManager.hasChanges());

    this.canSave = function canSave() {
        return this.person != null && !isSaving && (this.shared.form.$dirty || this.photoManager.hasChanges()) && this.shared.form.$valid;
    };

    this.isValidMunicipality = function isValidMunicipality() {
        // Do not show the warning when there are no default settings
        if (personState.systemSettings.DefaultValidMunicipalities && personState.systemSettings.DefaultValidMunicipalities.length > 0) {
            return utility.isValidMunicipality(this.person.MunicipalityCode, personState.systemSettings.DefaultValidMunicipalities);
        }
        return true;
    };

    this.lookup = function lookup() {
        if (!systemInfo.IsSparLookupEnabled) {
            dialogService.notify(
                "Denna tjänst hämtar folkbokförda uppgifter direkt från Statens Personadressregister (SPAR). Vill ni aktivera denna tjänst kontakta Troman på support@troman.se.",
                "Tjänsten inte aktiv");
        } else {
            const personalNumber = this.person.PersonalNumber;
            tromanServer.Integrations.lookupPerson(personalNumber).then(res => {
                if (!res) {
                    dialogService.notify("Inga uppgifter hittades.", "Inga uppgifter hittades");
                } else {
                    this.person.RegisteredName = res.RegisteredName || this.person.RegisteredName;
                    this.person.LastName = res.LastName || this.person.LastName;
                    this.person.MunicipalityCode = res.MunicipalityCode;
                    this.person.HasProtectedAddress = res.HasProtectedAddress;
                    this.person.IsDeceased = res.IsDeceased;
                    this.person.DeceasedDate = res.DeceasedDate;
                    this.person.homeAddress = this.person.homeAddress || {};
                    this.person.homeAddress.Address = res.Address?.Address || undefined;
                    this.person.homeAddress.ZipCode = res.Address?.ZipCode || undefined;
                    this.person.homeAddress.City = res.Address?.City || undefined;

                    this.person.SetSparData = {
                        MunicipalityCode: res.MunicipalityCode,
                        HasProtectedAddress: res.HasProtectedAddress,
                        IsDeceased: res.IsDeceased,
                        DeceasedDate: res.DeceasedDate,
                    };

                    this.shared.form.$setDirty();

                    var messages = ["Uppgifterna hämtades."];
                    if (!res.Address) {
                        messages.push("Adress saknades.");
                    }
                    if (res.IsDeceased) {
                        messages.push("Personen är avliden.");
                    }
                    
                    dialogService.notify(messages, "Uppgifter hämtade");
                }
            }).catch(dialogService.error);
        }
    };

    this.populateGender = function populateGender(ev) {
        var pnr = ev.currentTarget.value;
        if (/^(19|20)[0-9]{6}[-]?[0-9]{4}$/.test(pnr)) {
            if (pnr.charAt(pnr.length - 2) % 2 === 0)
                this.person.Gender = EnumValues.Gender.Woman;
            else
                this.person.Gender = EnumValues.Gender.Man;
        }
    };

    this.editingEarning = null;

    this.createEarning = function createEarning() {
        return {
            EmployerName: '',
            UnitPrice: 0.00,
            ValidFrom: utility.todayDate()
        };
    };

    this.earningsAdd = function earningsAdd() {
        if (!this.earningsApply()) return;

        this.editingEarning = this.createEarning();
        this.person.Earnings.push(this.editingEarning);
        this.earningsfocus = true;
    };

    this.earningsEdit = function earningsEdit(item) {
        if (!this.earningsApply()) return;

        this.earningsfocus = true;
        this.editingEarning = item;
    };

    this.earningsCanApply = function earningsCanApply() {
        if (!this.earningsform.$valid) return false;
        return true;
    };

    this.earningsApply = function earningsApply() {
        if (!this.editingEarning) return true;
        if (!this.earningsCanApply()) return false;
        this.editingEarning = null;
        return true;
    };

    this.earningsRemove = function earningsRemove() {
        if (!this.editingEarning) return;

        var index = this.person.Earnings.indexOf(this.editingEarning);
        if (index >= 0) {
            this.person.Earnings.splice(index, 1);
            this.editingEarning = null;
            this.earningsform.$setDirty();
        }
    };

    this.checkOverlaps = function checkOverlaps() {
        let earnings = _.groupBy(this.person.Earnings || [], x => x.EmployerName);
        let hasOverlapping = _.some(earnings, elist => {
            for (let ii = 1; ii < elist.length; ++ii) {
                let a = elist[ii - 1];
                let b = elist[ii];
                if (utility.isOverlapping(a.ValidFrom, a.ValidTo, b.ValidFrom, b.ValidTo)) {
                    var msg = 'Överlappande datum för arbetsgivaren "' + a.EmployerName + '"';
                    dialogService.error(msg);
                    return true;
                }
            }
        });
        return !hasOverlapping;
    };

    this._politikerAccess = this.person.HasPolitikerAccess ? (this.person.PolitikerExpireDate == null ? 0 : 2) : 1;
    this.initialHasPolitikerAccess = this.person.HasPolitikerAccess;

    Object.defineProperties(this, {
        politikerAccess: {
            enumerable: true,
            get: function () {
                return this._politikerAccess;
            },
            set: function (value) {
                if (value === this._politikerAccess) {
                    return;
                }

                if (value === 0 || value === 2) {
                    this.person.HasPolitikerAccess = true;
                } else if (value === 1) {
                    this.person.HasPolitikerAccess = false;
                } else {
                    throw new RangeError('Not valid value');
                }

                this.person.PolitikerExpireDate = null;
                this._politikerAccess = value;
            }
        }
    });

    this.isReportingExceptionActive = function () {
        if (this.person.ReportingDaysExceptionDate) {
            return utility.todayDate().getTime() <= this.person.ReportingDaysExceptionDate.getTime();
        }
        return false;
    };

    this.photoLoaded = function (evt) {
        let imageElement = evt.target;

        this.photoWarning = null;

        if (imageElement) {
            let nw = imageElement.naturalWidth;
            let nh = imageElement.naturalHeight;
            if (nw > 500 || nh > 500) {
                this.photoWarning = `Bilden är större (${nw}x${nh}) än rekommenderat`;
            }
        }
    };

    this.save = function save() {
        if (!this.canSave()) return;

        if (this.editingEarning) {
            if (!this.earningsCanApply()) return;
            this.earningsApply();
        }
        if (!this.checkOverlaps()) return;

        this.shared.form.$commitViewValue();
        this.shared.form.$setSubmitted();

        if (this.shared.form.$invalid) return;

        if (this.photoManager.hasChanges()) {
            this.person.SetProfilePhoto = this.photoManager.createUpdate();
        }

        isSaving = true;
        if (this.person.Id == null) {
            tromanServer.Persons.addEntity(this.person)
                .finally(() => { isSaving = false; })
                .then(rsp => {
                    stateService.forceGo('person.details', { personId: rsp.result.Id }, { reload: true, location: 'replace' });
                })
                .catch(dialogService.error);
        } else {
            tromanServer.Persons.updateEntity(this.person)
                .finally(() => { isSaving = false; })
                .then(() => {
                    stateService.forceReload('person');
                })
                .catch(dialogService.error);
        }
    };
}]);
